export default __webpack_public_path__ + "static/media/Ravenbone Pauldrons.890ce73a.jpg";